var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"headerScoreBtn",class:{ flash: _vm.flash },on:{"click":_vm.score}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ruby',[_vm._v("採点"),_c('rt',[_vm._v("さいてん")])])}]

export { render, staticRenderFns }